import { useRoutes } from 'react-router-dom';
import { DashboardPage, OperationList } from './pages';
import { Routes } from './state/constants';

export const BehaviourModule = () => {
  const routes = useRoutes([
    {
      path: Routes.dashboard,
      element: <DashboardPage />,
    },
    {
      path: Routes.operations,
      element: <OperationList />,
    },
  ]);

  return <>{routes}</>;
};
